import { getConnectorPrice, numberToLetter } from "./rateUtils";
import { formatDecimal } from "./format";

// Codes OCPI renvoyés par QoREST pour le type de prise.
const TYPE_LABELS = {
  IEC_62196_T2: "Type 2",
  IEC_62196_T2_COMBO: "CCS",
  IEC_62196_T1: "Type 1",
  IEC_62196_T1_COMBO: "CCS 1",
  CHADEMO: "CHAdeMO",
  DOMESTIC_E: "E/F",
  DOMESTIC_F: "E/F",
  IEC_60309_2_three_32: "P17",
};

const TYPE_ICONS = {
  IEC_62196_T2_COMBO: "/prise_CCS2.svg",
  CHADEMO: "/prise_CHAdeMO.svg",
  DOMESTIC_E: "/prise_type_e.svg",
  DOMESTIC_F: "/prise_type_e.svg",
};

export const connectorTypeLabel = (type) => TYPE_LABELS[type] || null;

const power = (connector) => (connector?.powerMax ? `${Math.floor(connector.powerMax)} kW` : null);

// « Connecteur A · Type 2 · 22 kW »
export const connectorSummary = (t, connector) =>
  [t("connector", { number: numberToLetter(connector?.number) }), connectorTypeLabel(connector?.type), power(connector)]
    .filter(Boolean)
    .join(" · ");

const PANELS = {
  // Arrivée, e-mail, attente de la borne : la borne et son tarif.
  station: { title: "panel.station", image: true, preauth: false },
  // Paiement : le récapitulatif, préautorisation comprise.
  summary: { title: "panel.summary", image: true, preauth: true },
  // Recharge en cours.
  charging: { title: "panel.charge", image: false, preauth: true },
  // Recharge terminée : la préautorisation n'a plus lieu d'être rappelée.
  done: { title: "panel.charge", image: false, preauth: false },
};

// Panneau « Votre borne / Récapitulatif / Votre recharge » de la version web.
//   connector  : la prise du parcours, si elle est connue ;
//   connectors : à défaut, les prises proposées (choix de la prise, reprise) ;
//   withStatus : affiche « Disponible » ou « En charge » après chaque prise.
export const buildStationPanel = ({ t, language, variant = "station", evcpData, connector, connectors, withStatus = false }) => {
  const config = PANELS[variant];
  const list = connector ? [connector] : connectors || [];
  const rows = [];

  if (evcpData?.address) {
    rows.push({ icon: "/Map_Point.svg", label: t("panel.address"), value: evcpData.address });
  }

  if (withStatus) {
    list.forEach((c) =>
      rows.push({
        icon: TYPE_ICONS[c.type] || "/prise_type_2.svg",
        label: t("panel.connector"),
        value: `${t("connector", { number: numberToLetter(c.number) })} · ${c.hasTransaction ? t("in_charge") : t("available")}`,
      })
    );
  } else if (list.length === 1) {
    rows.push({ icon: TYPE_ICONS[list[0].type] || "/prise_type_2.svg", label: t("panel.connector"), value: connectorSummary(t, list[0]) });
  } else if (list.length > 1) {
    const value = [t("panel.connectorsCount", { count: list.length }), connectorTypeLabel(list[0].type), power(list[0])]
      .filter(Boolean)
      .join(" · ");
    rows.push({ icon: "/prise_type_2.svg", label: t("panel.connector"), value });
  }

  const priced = connector || list[0];
  if (priced) {
    rows.push({
      icon: "/Euro.svg",
      label: t("panel.rate"),
      value: `${formatDecimal(getConnectorPrice(priced, evcpData), language, 2)} €/kWh`,
    });
  }

  if (config.preauth) {
    rows.push({ icon: "/Shield_Check.svg", label: t("panel.preauth"), value: t("panel.preauthValue") });
  }

  return rows.length ? { title: t(config.title), image: config.image, rows } : null;
};
